import { FieldType } from "@contentful/app-sdk";
import { documentToHtml } from "../lib";

export const handleFieldTypesBeforeTranslation = (value: any, fieldType: FieldType): string[] => {
    if (!value) {
        return [];
    }

    if (fieldType === "RichText") {
        return [documentToHtml(value)];
    }

    if (fieldType === "Array") {
        return value;
    }

    return [value];
};
